//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ModalWithTitleBar from '@/components/Shared/ModalWithTitleBar'
import Button from '@/components/Shared/Button.vue'
import ModalUsersWithoutEmail from '@/components/Projects/users/ModalUsersWithoutEmail.vue'
import AddCollaborator from './AddCollaborator.vue'
import SearchCollaborator from './SearchCollaborator.vue'

export default {
  components: {
    ModalWithTitleBar,
    Button,
    SearchCollaborator,
    AddCollaborator,
    ModalUsersWithoutEmail,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    employees: {
      type: Array,
      default: () => [],
    },
    employessInProject: {
      type: Array,
      default: () => [],
    },
    projectId: {
      type: Number,
      required: true,
    },
    sendInvitation: {
      type: Boolean,
      default: false,
    },
    customInvitation: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    activeTab: 0,
    usersToAdd: [],
    project: {
      users: [],
    },
    isSubmitDisabled: false,
    isFormValid: false,
    isShowModalUsersWithoutEmail: false,
    handleAddSelected: '',
  }),
  watch: {
    activeTab(value) {
      if (value === 0) this.isSubmitDisabled = false
      if (value === 1) this.isSubmitDisabled = !this.isFormValid
    },
  },
  methods: {
    onToggle() {
      this.$emit('toggle')
      this.isFormValid = false
      this.activeTab = 0
    },
    setUsersToAdd(users) {
      this.usersToAdd = users
    },
    async handleAddUsers() {
      this.handleAddSelected = 'add-user'
      if (this.activeTab === 0) {
        this.$store.commit('loading', true)
        try {
          await this.$repository.invitation.addExistingCollaboratorsToProjectAndNotify(
            {
              projectId: this.projectId,
              usersIds: this.usersToAdd.map((user) => user.id),
              sendInvitation: this.sendInvitation,
            }
          )
        } catch (error) {
          this.$buefy.notification.open({
            message: `Error al agregar usuarios al proyecto`,
            type: 'is-danger',
            hasIcon: true,
            duration: 5000,
          })
        }

        this.$emit('user-created-and-close')
        this.$store.commit('loading', false)
      }
      if (this.activeTab === 1) {
        const success = await this.$refs.addCollaborator.submit()
        if (success) {
          this.handleCreateAndClose()
        }
      }
    },
    async handleAddUsersAndCreateAnother() {
      this.handleAddSelected = 'add-another-user'
      const success = await this.$refs.addCollaborator.submit()
      if (success) {
        this.handleCreate()
      }
    },
    async handleCreateUserWithoutEmail() {
      const success = await this.$refs.addCollaborator.saveUser()
      if (success && this.handleAddSelected === 'add-another-user') {
        this.handleCreate()
      }
      if (success && this.handleAddSelected === 'add-user') {
        this.handleCreateAndClose()
      }
    },
    handleMassiveModel() {
      this.$emit('import-massive-users')
    },
    handleUserWithoutEmailConfirmation() {
      this.isShowModalUsersWithoutEmail = true
    },
    handleValidationInvalid(invalid) {
      this.isFormValid = !invalid
      if (this.activeTab === 0) this.isSubmitDisabled = false
      else {
        this.isSubmitDisabled = invalid
      }
    },
    handleUserWithError(message) {
      this.$emit('user-with-error', message)
    },
    toggleModalUsersWithoutEmail() {
      this.isShowModalUsersWithoutEmail = !this.isShowModalUsersWithoutEmail
    },
    handleCreateAndClose() {
      this.$emit('user-created-and-close')
      this.isFormValid = false
      this.activeTab = 0
      this.handleAddSelected = ''
    },
    handleCreate() {
      this.$emit('user-created')
      this.$refs.addCollaborator.reset()
      this.isFormValid = false
      this.handleAddSelected = ''
    },
  },
}
